
import React from 'react';
import PropTypes from 'prop-types';
import '../App.css';

import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core / Typography';

const styles = theme => ({
  container:{
    position: 'relative',
    height: '0',
    //backgroundColor:'yellow',
    textAlign:'left',
    //paddingLeft:'25px',
  },
  energyBar: {
    position: 'absolute',  
    textAlign: 'left',
    left: '10px',
    //backgroundColor:'green',
    [theme.breakpoints.down('xs')]: {
      top: '200px',
      width: '120px',
      height: '120px',
    },
    [theme.breakpoints.up('sm')]: {
      top: '320px',
      width: '200px',
      height: '150px',
    },
    [theme.breakpoints.up('md')]: {
      top: '320px',
    },
    [theme.breakpoints.up('lg')]: {
     top: '350px',
    },
  },
  solarColorBox: {
    display: 'flex',
    //width: '100%',
    //marginLeft: '2%',
    height: '30px',
    //background: 'linear-gradient(to right, #FCD679, #FECF09, #FBB317, #F99F1B, #F48320, #EC6424, #EF4523, #EC1D25, #AF2324,#941A1D, #6E0E10)',
    //updated colorArray based on vague idea of lighter colors
    //background: 'linear-gradient(to right, #ffffe0,#fff6ce,#ffeebe,#ffe5ab,#ffdd9a,#ffd587,#ffcc74,#ffc360,#ffb849,#ffaf30,#ffa500)',
    // updated colorArray based on specific colors provided in issue list 20180925 line 31
    // using https://gka.github.io/palettes/
    //background: 'linear-gradient(to right, #fff292,#fae67c,#f4d968,#eece56,#e7c247,#e1b538,#daab2c,#d39e21,#cd9219,#c68614,#bf7a13)',    
    background: 'linear-gradient(to right, #fff292,#ffeb81,#ffe471,#ffdc5e,#ffd349,#ffcc33,#fbbb3b,#f7aa41,#f29945,#ed8749,#e8754c)',
  },
  windColorBox: {
    display: 'flex',
    width: '65%',
    //marginLeft: '2%',
    height: '30px',
    //background: 'linear-gradient(to right, #1EB0E6,#059ED1,#0190BE,#027CA3,#046786,#085F7C,#034F66,#034054,#013244,#002838,#010101)',
    //updated colorArray based on vague idea of lighter colors
    //background: 'linear-gradient(to right, #f0f8ff, #e2f2ff, #d3edff, #c3e6ff, #b3e1ff, #a3dbff, #90d5ff, #7cd0ff, #66cbff, #46c5ff, #00bfff)',
    // updated colorArray based on specific colors provided in issue list 20180925 line 31
    // using https://gka.github.io/palettes/
    background: 'linear-gradient(to right, #bfd6e2,#abc8d7,#98bacc,#87acc0,#779eb3,#6890a5,#5a8197,#4e7488,#43667a,#39596a,#304c5b)',
  },
  allColorBox: {
    display: 'flex',
    width: '65%',
    //marginLeft: '2%',
    height: '30px',
    //background: 'linear-gradient(to right, #B7DA94,#73BF44,#7CC243,#83C341,#8BC63F,#99C03C,#B0C238,#C2B839,#918E34,#787630,#5D5322)',
    //updated colorArray based on vague idea of lighter colors
    //background: 'linear-gradient(to right, #f0fff0, #e8f8de, #e1f2cd, #d8ecba, #d0e6a9, #c8df98, #bfd986, #b5d274, #accd63, #a3c651, #99c03c)',
    // updated colorArray based on specific colors provided in issue list 20180925 line 31
    // using https://gka.github.io/palettes/
    background: 'linear-gradient(to right, #b7dcad,#a2d094,#8cc47c,#7ab769,#67aa58,#579d4a,#488f3e,#3b8134,#2e742d,#236628,#1a5924)',
  },
});

function MapLegend(props) {
  const { classes } = props;

  let colorBoxClass
  
  if (props.currentTech.solar) {
    if (props.currentTech.wind) {
      colorBoxClass = classes.allColorBox
    }
    else {
      if (props.currentTech.windOffshore) {
        colorBoxClass = classes.allColorBox
      }
      else {
        colorBoxClass = classes.solarColorBox
      }
    }
  }
  else {
    colorBoxClass = classes.windColorBox
  }

  let inhabitant
  switch (props.lang) {
    case "de":
      inhabitant = "Einwohner"
      break;
    case "en":
      inhabitant = "inhabitant"
      break;
    case "fr":
    default:
      inhabitant = "habitant"
  }
  const mapUnit = props.currentMode === 'realtime' ?
    (props.currentFilter === 'energy' ? "MWh" : (props.currentFilter === 'inhabitants' ? ("Wh/"+inhabitant) : "MWh/100 km²")) :
    (props.currentFilter === 'energy' ? "GWh" : (props.currentFilter === 'inhabitants' ? ("Wh/"+inhabitant) : "GWh/100 km²"))

  return (
    <div className={classes.container}>
      <div className={classes.energyBar}>
        <div className={colorBoxClass} />
        <div style={{ display: "flex", justifyContent: "space-between",marginRight:'0%', }}>
          <div>0</div>
          <div>{props.currentMode === 'realtime' ? Math.round(props.maxValue) : Math.round(props.maxValue / 1000)} {mapUnit}</div>
        </div>
      </div>
    </div>
  );
}

MapLegend.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MapLegend);
